import React from "react";
import { setupIonicReact } from "@ionic/react";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import { useSelector } from "react-redux";

setupIonicReact();

// Reusable Breadcrumb Component
const Breadcrumb = ({
  items,
}: {
  items: { label: string; link?: string }[];
}) => {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center px-5 py-3 text-gray-700 border border-gray-200 rounded-lg bg-primary-50 dark:bg-primary-500 dark:border-primary-200"
    >
      <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
        {items.map((item, index) => (
          <li key={index} className="inline-flex items-center">
            {item.link ? (
              <a
                href={item.link}
                className="inline-flex items-center text-xs font-light text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
              >
                {index > 0 && (
                  <svg
                    className="rtl:rotate-180 block w-2 h-2 mx-1 text-gray-400 font-thin"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 6 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 9 4-4-4-4"
                    />
                  </svg>
                )}
                {item.label}
              </a>
            ) : (
              <span className="text-xs font-light text-gray-500 dark:text-gray-400">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

const MainDashboard: React.FC = () => {
  const user = useSelector((state: any) => state.auth.authState.authUser?.user);

  return (
    <>
      <div className="rounded-lg max-w-full overflow-x-auto p-5 bg-white ">
        <div className="font-sans overflow-x-auto bg-white rounded-lg">
          <div className="bg-white">
            <h1 className="text-sm font-light flex items-center p-4 pl-6">
              <i className="fa-solid fa-user text-lg font-light mr-2"></i>
              Welcome! {user?.name ?? "Guest"}
            </h1>
            <hr className="border-t border-black" />
          </div>

          <div className="grid grid-cols-2 gap-4 p-2 mt-4">
            {/* Section 1 */}
            <div>
              <Breadcrumb
                items={[
                  { label: "Home", link: "#" },
                  { label: "Templates", link: "#" },
                  { label: "Flowbite" },
                ]}
              />
              <p className="mb-3 text-gray-500 dark:text-gray-400">
                Manage work seamlessly through collaborative tools. Easily track
                progress and simplify ITSM tasks.
              </p>
              <p className="text-gray-500 dark:text-gray-400">
                Improve service delivery and manage changes with full
                transparency.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <Breadcrumb
                items={[
                  { label: "Another Home", link: "#" },
                  { label: "Another Templates", link: "#" },
                ]}
              />
              <p className="mb-3 text-gray-500 dark:text-gray-400">
                Streamline development processes and ensure faster resolutions
                with rich contextual data.
              </p>
              <p className="text-gray-500 dark:text-gray-400">
                Empower your teams to work smarter and deliver value faster.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainDashboard;
